import React, { ReactElement } from 'react';
import { FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from 'common/components/antd/Button/Button';
import { Form } from 'common/components/antd/Form/Form';
import { Input } from 'common/components/antd/Input/Input';
import { STitle, SContainer } from './filters-form.component.style';
import { ECounterpartiesFilterFormKeys } from '../../enums/conterparties.enums';

type TProps = {
  onSubmit: (values: any) => void;
  form: FormInstance;
  isLoading: boolean;
};

export const FiltersFormComponent = ({ onSubmit, form, isLoading }: TProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <SContainer>
      <STitle>{t('usrRoleMng.counterparties.filters.title')}</STitle>
      <Form onFinish={onSubmit} form={form}>
        <Form.Item name={ECounterpartiesFilterFormKeys.GUID}>
          <Input
            placeholder={t('usrRoleMng.counterparties.filters.guid.placeholder') as string}
            size="middle"
            allowClear
          />
        </Form.Item>
        <Form.Item name={ECounterpartiesFilterFormKeys.Name}>
          <Input
            placeholder={t('usrRoleMng.counterparties.filters.name.placeholder') as string}
            size="middle"
            allowClear
          />
        </Form.Item>
        <Form.Item name={ECounterpartiesFilterFormKeys.Code}>
          <Input
            placeholder={t('usrRoleMng.counterparties.filters.code.placeholder') as string}
            size="middle"
            allowClear
          />
        </Form.Item>
        <Form.Item name={ECounterpartiesFilterFormKeys.HoldingName}>
          <Input
            placeholder={t('usrRoleMng.counterparties.filters.holdingName.placeholder') as string}
            size="middle"
            allowClear
          />
        </Form.Item>
        <Button type="primary" htmlType="submit" width="100%" disabled={isLoading} loading={isLoading}>
          {t('usrRoleMng.counterparties.filters.button.filter')}
        </Button>
      </Form>
    </SContainer>
  );
};
